import { useState, useRef } from "react";
import Loader from "../../../components/loader";
import UiButton from "../../../components/button";
import TextInput from "../../../components/textinput/TextInput";
import { Button, Row, Col } from "react-bootstrap";
import UiTable from "../../../components/table/Table";
import {
  useInvestorData,
  useNetworkOptions,
} from "../../../context/contractDataLoaderService";
import VerticallyModal from "../../../components/modal/VerticallyModal";
import {
  Liquidity,
  Client,
  contractAddress,
} from "@verified-network/verified-sdk";
import Web3 from "web3";
import { ethers, providers } from "ethers";
import ERC20ABI from "../../../utils/abi/ERC20.json";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
} from "../../../utils/constants";
import { toast } from "react-toastify";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
  NETWORKS_INFO,
} from "../../../utils/helpers/networks";
import { useGlobal } from "../../../context/globalContext";

function TokenDetails(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  let { data, loading } = useInvestorData();
  const [showModal, setShowModal] = useState(false);
  const [tokenAddress, setTokenAddress] = useState("");
  const [priceFeed, setPriceFeed] = useState("");
  const [tokenName, setTokenName] = useState("");
  const [loadingModal, setLoadingModal] = useState(false);
  const [changeContent, setChangeContent] = useState(false);
  const modalContent = useRef(null);
  const { data: networkOptions } = useNetworkOptions();

  let liquidityContract, clientContract;

  if (provider && provider.getSigner && chainId && address) {
    liquidityContract = new Liquidity(
      signer,
      contractAddress[chainId].Liquidity,
    );
    clientContract = new Client(signer, contractAddress[chainId].Client);
  }

  const handleModalHide = () => {
    setShowModal(false);
    setTokenAddress("");
    setPriceFeed("");
    setTokenName("");
  };

  const addToken = async () => {
    if (!web3.utils.isAddress(tokenAddress)) {
      alert("Enter proper token address");
      return;
    }
    if (!web3.utils.isAddress(priceFeed)) {
      alert("Enter proper price feed address");
      return;
    }
    if (tokenName === "" || tokenName?.length === 0) {
      alert("Enter proper token name");
      return;
    }
    setLoadingModal(true);

    try {
      await liquidityContract
        .supportTokens(tokenAddress, tokenName, priceFeed)
        .then((res) => {
          setLoadingModal(false);
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);

            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error("Transaction failed", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `{${networks[chainId].blockExplorerUrls[0]}/tx/${error?.err?.transactionHash}`;
      setLoadingModal(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };

  const removeToken = async () => {
    if (!web3.utils.isAddress(tokenAddress)) {
      alert("Enter a valid token address");
      return;
    }
    setLoadingModal(true);

    try {
      const tx = await liquidityContract.removeToken(tokenAddress);
      if (tx.code === "ACTION_REJECTED") {
        toast.error("Transaction rejected by user!", ToastOptions);
      } else if (tx?.status === 0) {
        const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${tx.response.hash}`;
        toast.success(SuccessToast(transactionLink), ToastOptions);

        setChangeContent(true);
        modalContent.current.innerHTML = "";
      } else {
        toast.error("Remove Token Transaction Failed.", ToastOptions);
      }

      setLoadingModal(false);
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `{${networks[chainId].blockExplorerUrls[0]}/tx/${error.err.transactionHash}`;
      setLoadingModal(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };

  let headers = [
    { label: "Date(UTC)", val: "date" },
    { label: "Investor Wallet", val: "address" },
    { label: "Name", val: "investorName" },
    { label: "Country", val: "investorCountry" },
    { label: "Token Invested", val: "tokenName" },
    { label: "Amount Invested", val: "amountInvested" },
    { label: "Amount Issued", val: "amountIssued" },
    { label: "Role", val: "investorRole" },
    { label: "Call Action", val: "tokenCallAction" },
  ];

  return (
    <>
      {loading || loadingModal ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="w-50">
            <h3 className="text-left">Liquidity providers</h3>
          </div>
          <div className="w-50 text-right">
            <Button
              onClick={() => {
                setShowModal(true);
              }}
            >
              Add Token
            </Button>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={data || []}
            hover
            bordered={false}
            signer={signer}
            ower={account}
            networkOptions={networkOptions}
            contract={clientContract}
            chainId={chainId}
            account={account}
            web3={web3}
            verifiedWalletDetails={verifiedWalletDetails}
          />
        </div>
      </section>
      <VerticallyModal
        key="connectProvider"
        showModal={showModal}
        modalOnHide={handleModalHide}
        modalSize={"lg"}
        modalHeading={<h3>Token Details</h3>}
        withFooter={false}
      >
        {changeContent && (
          <UiButton
            onClick={() => {
              setShowModal(false);
              setChangeContent(false);
            }}
            buttonVariant="primary"
            buttonClass="SignUpButton flex-1 ml-0"
            buttonText="Click to close this form&nbsp;&rarr;"
            type="submit"
          />
        )}
        <div className="d-grid gap-2" ref={modalContent}>
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={4}>
                <b>Token Name</b>
              </Col>
              <Col className="pl-0" xs={6}>
                <TextInput
                  placeholder="Token Name(e.g USDC, WETH)"
                  onChange={(e) => setTokenName(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={4}>
                <b>Token Address</b>
              </Col>
              <Col className="pl-0" xs={6}>
                <TextInput
                  placeholder="Token Address"
                  onChange={(e) => setTokenAddress(e.target.value)}
                />
              </Col>
            </Row>

            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={4}>
                <b>Token Price Feed</b>
              </Col>
              <Col className="pl-0" xs={6}>
                <TextInput
                  placeholder="Token Price Feed Against Desired Currency"
                  onChange={(e) => setPriceFeed(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col className="pl-0" xs={4} />
              <Col className="pl-0" xs={4}>
                <UiButton
                  onClick={() => {
                    addToken();
                  }}
                  buttonVariant="primary"
                  buttonClass="SignUpButton flex-1 ml-0"
                  buttonText="Add Token"
                  type="submit"
                />
                <Col className="pl-0" xs={4} />
              </Col>
            </Row>
          </Row>
        </div>
      </VerticallyModal>
    </>
  );
}

export default function AdminTokens(props) {
  return <TokenDetails {...props} />;
}
